import axios from "axios";

export async function listServicesRequest(user) {
    console.log("in list services",user)

    let client = "GARDENHELP"

    let headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
        client: client,
    }
    if (user != null) {
        headers.Authorization = "Bearer " + user.access_token
    }

    let services = [];

    await axios
        .get("/services/list", {
            headers: headers,
        })
        .then((response) => {
            // console.log(response);
            services = response.data;
        });

    // console.log(services)
    return services
}

export function listExperienceLevels() {
    let experience_level_options = [
        { name: "0-2 years", id: "0-2 years" },
        { name: "2-5 years", id: "2-5 years" },
        { name: "5+ years", id: "5+ years" },
    ]
    return experience_level_options
}

export function listPropertyTypes() {
    let property_types = [
        { name: "Commercial", id: "Commercial" },
        { name: "Residential", id: "Residential" }
    ]
    return property_types
}

export function getJobStatusClassAndStr(status) {
    let job_status = ''
    if (status == 'pending') {
        job_status = 'New';
    } else if (status == 'assigned') {
        job_status = 'Assigned';
    } else if (status == 'accepted') {
        job_status = 'Accepted';
    } else if (status == 'rejected') {
        job_status = 'Rejected';
    }else if (status == 'accepted_quote') {
        job_status = 'Customer Accepted';
    } else if (status == 'on_route') {
        job_status = 'On Route To Location';
    } else if (status == 'arrived') {
        job_status = 'Arrived At Location';
    } else if (status == 'in_progress') {
        job_status = 'Job In Progress';
    } else if (status == 'complete') {
        job_status = 'Job Completed';
    }
    return job_status
}
export function getStatusPercentage(status) {
    let status_list = ['pending', 'assigned', 'accepted','accepted_quote', 'on_route', 'arrived', 'in_progress', 'complete']
    let status_index = status_list.indexOf(status)
    return ((status_index + 1) / status_list.length) * 100
}

export function getJobStatusListForFilter() {
    let status_list = [
        { id: "pending", name: "New" },
        { id: "assigned", name: "Assigned" },
        { id: "accepted", name: "Accepted" },
        { id: "rejected", name: "Rejected" },
        { id: "accepted_quote", name: "Customer Accepted" },
        { id: "on_route", name: "On Route To Location" },
        { id: "arrived", name: "Arrived At Location" },
        { id: "in_progress", name: "Job in progress" },
        { id: "complete", name: "Job Completed" },
    ]
    return status_list
}

export function getServicesNamesFromObject(service_obj_arr, newline = true) {

    var services = service_obj_arr.map(function (item) {
        return item['name'];
    });

    if (newline) {
        return services.toString().replaceAll(",", ", <br/>")
    }else{
        return services.toString().replaceAll(",", ", ")
    }
}

export function listCountries(){
    let countries = [
        { name: "Ireland", id: "Ireland" },
        { name: "United Kingdom", id: "United Kingdom" }
    ]
    return countries
}


// WEBPACK FOOTER //
// ./src/utils/helper-functions-garden-help.js